import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Angular Material Modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Third-party
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule, NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { FullCalendarModule } from '@fullcalendar/angular';

// Custom
import { JwtInterceptor } from './helper/jwt-interceptor';
import { OfflineInterceptor } from './helper/offline-interceptor';
import { CustomMatPaginatorIntl } from 'src/custom-mat-paginator-intl';
import { CustomDateAdapter } from 'src/CustomDateAdapter';
import { NgChartsModule } from 'ng2-charts';

registerLocaleData(localeFr);

@NgModule({
declarations: [
AppComponent,
],
imports: [
BrowserModule,
BrowserAnimationsModule,
AppRoutingModule,
HttpClientModule,
FormsModule,
ReactiveFormsModule,


// Angular Material
MatFormFieldModule,
MatInputModule,
MatTableModule,
MatPaginatorModule,
MatSortModule,
MatToolbarModule,
MatButtonModule,
MatIconModule,
MatDialogModule,
MatProgressSpinnerModule,
MatSlideToggleModule,
MatDatepickerModule,
MatSelectModule,
MatNativeDateModule,
MatTabsModule,
MatAutocompleteModule,
MatCheckboxModule,
MatRadioModule,
MatChipsModule,
MatSnackBarModule,

// Third-party
NgxMatDatetimePickerModule,
NgxMatTimepickerModule,
NgxMatNativeDateModule,
FullCalendarModule,
NgChartsModule,

],
providers: [
{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
{ provide: HTTP_INTERCEPTORS, useClass: OfflineInterceptor, multi: true },
{ provide: LOCALE_ID, useValue: 'fr-FR' },
{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
{ provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
DatePipe
],
bootstrap: [AppComponent]
})
export class AppModule { }
